import React, { useState } from "react";
import { Headline, Paragraph, Icon, SimpleList } from "./ui";

const Card = ({
  headline,
  introduction,
  shortDescription,
  keyPoints,
  badge,
  image,
  color = "var(--color-primary)",
  noImage = false,
  tabbed = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="card-item bg-[var(--color-secondary-dark)] rounded-sm shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 h-full flex flex-col">
      {!noImage && (
        <div className="relative h-64 overflow-hidden">
          <img
            src={
              image
                ? `${process.env.PUBLIC_URL}/${image}`
                : `${process.env.PUBLIC_URL}/porsche-placeholder.avif`
            }
            alt={headline}
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
          />
          {badge && (
            <div className="absolute top-3 left-3">
              <Paragraph
                variant="tiny"
                color="primary"
                noSpacing
                className="bg-[var(--color-secondary)] px-3 py-1 rounded-full shadow font-semibold"
              >
                {badge}
              </Paragraph>
            </div>
          )}
        </div>
      )}

      <div className="px-12 py-8 flex-1 flex flex-col">
        <div className="mb-4">
          <Headline
            variant="h5"
            color="primary"
            className="pt-2 line-clamp-3 text-left"
          >
            {headline}
          </Headline>
        </div>

        <div className="flex-1">
          <Paragraph
            variant="medium"
            color="primary"
            className="font-medium"
            dangerouslySetInnerHTML={{
              __html: shortDescription || introduction,
            }}
          />

          {/* Collapsible keyPoints */}
          {keyPoints && keyPoints.length > 0 && (
            <div
              className={`transition-all duration-300 overflow-hidden ${
                isExpanded ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
              }`}
            >
              <div className="mb-4">
                <SimpleList
                  items={keyPoints}
                  variant="transparent"
                  spacing="none"
                  contentSpacing="none"
                  useIcon={true}
                  iconName="check"
                  iconSize="lg"
                  bulletColor="text-green-600"
                  textVariant="medium"
                  showBottomMargin={false}
                  className=""
                  color={tabbed ? "primary" : color}
                />
              </div>
            </div>
          )}
        </div>

        {/* Toggle button - only show if there are keyPoints */}
        {/* {keyPoints && keyPoints.length > 0 && (
          <button
            onClick={toggleExpanded}
            className="mt-auto flex items-center justify-center gap-2 w-full py-2 text-gray-900 transition-colors duration-200 border-t border-gray-300 bg-gray-100/50 hover:bg-gray-200/50"
          >
            <Paragraph variant="tiny" noSpacing className="font-medium">
              {isExpanded ? 'Weniger anzeigen' : 'Mehr anzeigen'}
            </Paragraph>
            <Icon
              name={isExpanded ? "chevron-up" : "chevron-down"}
              size="xs"
              className="transition-transform duration-200"
            />
          </button>
        )} */}
      </div>
    </div>
  );
};

export default Card;
